module.exports = __webpack_public_path__ + "static/media/Tentacle_Obey_Opening.c87be72d.mp3";